var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-form",
    { ref: "form", attrs: { model: _vm.formModel, rules: _vm.filedsRules } },
    _vm._l(_vm.fileds, function (item) {
      return _c(
        "yxt-form-item",
        {
          key: item.prop,
          attrs: { label: _vm.$t(item.label), prop: item.prop },
        },
        [
          _c(item.comp, {
            ref: "formRef",
            refInFor: true,
            tag: "component",
            attrs: { formModel: _vm.formModel, attrs: item.attrs },
            model: {
              value: _vm.formModel[item.prop],
              callback: function ($$v) {
                _vm.$set(_vm.formModel, item.prop, $$v)
              },
              expression: "formModel[item.prop]",
            },
          }),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }